module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-customer"
  }, [_c('div', {
    staticClass: "contain"
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      },
      "title": "企业注册"
    },
    on: {
      "on-click-back": function($event) {
        return _vm.$router.push({
          path: '/login'
        })
      }
    }
  }), _vm._v(" "), _c('group', {
    attrs: {
      "gutter": "0",
      "label-width": "90px"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "*手机/邮箱",
      "disabled": "",
      "placeholder": "中国大陆手机或邮箱",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.account = _vm.holdEmoji(_vm.account).trim()
      }
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*联系人",
      "placeholder": "必填",
      "required": "",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.name = _vm.holdEmoji(_vm.name).trim()
      }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*企业名",
      "placeholder": "必填",
      "required": "",
      "keyboard": "text"
    },
    on: {
      "on-blur": function($event) {
        _vm.corp_name = _vm.holdEmoji(_vm.corp_name).trim()
      }
    },
    model: {
      value: (_vm.corp_name),
      callback: function($$v) {
        _vm.corp_name = $$v
      },
      expression: "corp_name"
    }
  }), _vm._v(" "), (_vm.mainIndustry.length > 0) ? _c('cell', {
    attrs: {
      "title": "副行业",
      "isLink": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openIndustrySub.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": ""
    },
    slot: "default"
  }, [(_vm.subIndustry && _vm.subIndustry.length > 0) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.subIndustry.map(function (item) {
    return item.name
  }).join('/')))])]) : _c('span', [_vm._v("点击选择")])])]) : _vm._e(), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "*国家",
      "columns": 1,
      "show-name": "",
      "placeholder": "请选择国家",
      "data": _vm.countryList
    },
    on: {
      "on-change": _vm.onCountryChange
    },
    model: {
      value: (_vm.country),
      callback: function($$v) {
        _vm.country = $$v
      },
      expression: "country"
    }
  }), _vm._v(" "), (_vm.showMoreLocation) ? _c('x-address', {
    attrs: {
      "title": "*地区",
      "placeholder": "请选择地区",
      "raw-value": "",
      "list": _vm.locationList,
      "value-text-align": "right"
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "*详细地址",
      "placeholder": "请输入详细地址",
      "text-align": "right",
      "keyboard": "address"
    },
    on: {
      "on-blur": function($event) {
        _vm.address = _vm.holdEmoji(_vm.address).trim()
      }
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.positionModel = true
      }
    },
    slot: "right"
  })]), _vm._v(" "), _c('cell', {
    attrs: {
      "value": "*请上传门店图片"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("门店照片")])]), _vm._v(" "), _c('kp-file-upload', {
    attrs: {
      "name": 'files',
      "max-length": 6,
      "is-edit": _vm.isEdit,
      "multiple": true
    },
    on: {
      "update-success": _vm.updateSuccess,
      "update-error": function (res) { return (_vm.files = _vm.files.concat([])); }
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  })], 1)], 1), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "success",
      "width": "150px",
      "time": 800
    },
    on: {
      "on-hide": function($event) {
        return _vm.$router.go(-1)
      }
    },
    model: {
      value: (_vm.showSuccessToast),
      callback: function($$v) {
        _vm.showSuccessToast = $$v
      },
      expression: "showSuccessToast"
    }
  }, [_vm._v("保存成功")]), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "cancel",
      "width": "150px",
      "time": 1000
    },
    model: {
      value: (_vm.showErrorToast),
      callback: function($$v) {
        _vm.showErrorToast = $$v
      },
      expression: "showErrorToast"
    }
  }, [_vm._v("保存失败,没有获取到错误信息，requestid是：" + _vm._s(this.errorRequestId))]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.getWxAddress
    }
  }, [_vm._v("一键获取微信地址")]), _vm._v(" "), _c('kp-bottom-btn', {
    attrs: {
      "title": "完成注册",
      "disabledText": "正在提交",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.checkForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('industry-checker', {
    attrs: {
      "value": _vm.industrySubVisible,
      "max": 2,
      "disable": _vm.mainIndustry,
      "title": "请选择企业副营行业",
      "data": _vm.industryList
    },
    on: {
      "close": _vm.closeIndustrySub,
      "ok": _vm.industrySubOk
    }
  }), _vm._v(" "), _c('position', {
    attrs: {
      "visable": _vm.positionModel
    },
    on: {
      "on-hide": function($event) {
        _vm.positionModel = false
      },
      "location": _vm.locationFn
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a686239","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
// module id = 328
// module chunks = 1